import React from 'react';
import { FormControlLabel, Grid, Switch, TextField } from '@mui/material';
import FormDialog from '../../common/FormDialog';

const ConductCategoryFormDialog = ({ open, onClose, onSubmit, editingCategory, formData, setFormData, saving, isMobile = false }) => (
  <FormDialog
    open={open}
    onClose={onClose}
    onSubmit={onSubmit}
    title={editingCategory ? 'Edit Conduct Category' : 'Add Conduct Category'}
    saving={saving}
    isMobile={isMobile}
    maxWidth="sm"
  >
    <Grid container spacing={2} sx={{ pt: 1 }}>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Category Code"
          value={formData.category_code}
          onChange={(e) => setFormData({ ...formData, category_code: e.target.value.toUpperCase() })}
          placeholder="e.g. ATTEND"
          helperText="Auto-generated from name if left blank"
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label="Display Order"
          type="number"
          value={formData.display_order}
          onChange={(e) => setFormData({ ...formData, display_order: e.target.value })}
          placeholder="e.g. 1"
          helperText="Order on report card"
          inputProps={{ min: 1 }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          label="Category Name"
          value={formData.category_name}
          onChange={(e) => setFormData({ ...formData, category_name: e.target.value })}
          placeholder="e.g. Attendance, Behaviour, Punctuality"
          required
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          multiline
          rows={3}
          label="Description"
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          placeholder="e.g. Measures student attendance and punctuality"
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={<Switch checked={formData.is_active ?? true} onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })} />}
          label="Active"
        />
      </Grid>
    </Grid>
  </FormDialog>
);

export default ConductCategoryFormDialog;
